module.exports = __webpack_public_path__ + "static/media/about-truss-4.1b2be8c4.png";